<div class="mt-2 p-8 gap-3">
    <div class="flex justify-between items-center pb-4">
        <div class="text-lg text-gray-700 font-bold ">Ocorrências OS</div>
        <div class="flex justify-center items-center gap-3">
            <button mat-button class="btn-tg-cancel" (click)="close()">
                Fechar
            </button>
            <button mat-button class="btn-tg" (click)="newOccurrence()">Adicionar</button>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="p-2 mt-5">
        @if(!loading){

        @if(itemsList.length > 0){
        <table-list-simple [dataSource]="itemsList" [columns]="columns" (viewItem)="viewItem($event)"
            (deleteItem)="deleteItem($event)" />
        }@else{
        <h3 class="text-center">Nenhuma ocorrência associada.</h3>
        }
        }@else{
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }

    </div>
</div>